import { Component, input, output } from '@angular/core';
import { MenuTabs } from 'src/app/models/menu.model';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  standalone: false,
})
export class MainMenuComponent {
  /* Indicates whether the application is running inside a mobile container */
  isMobileApp = input<boolean>(false);

  /* Active language used for menu label rendering */
  language = input<string>('en');

  /* Menu opening direction configuration */
  menuDirection = input<string>('');

  /* Menu tab configuration used to render menu items */
  tabs = input<MenuTabs[]>([]);

  /* When true, menu items are visible but non-interactive */
  disabled = input<boolean>(false);

  /* Associated content container ID for ion-menu */
  contentId = input<string>('my-content');

  /* Emits logout intent to the parent container */
  emitLogout = output<void>();

  /* Triggers logout action */
  logout(): void {
    this.emitLogout.emit();
  }

}
